import { render, staticRenderFns } from "./ShapeRecognition.vue?vue&type=template&id=4b34327a&scoped=true"
import script from "./ShapeRecognition.vue?vue&type=script&lang=js"
export * from "./ShapeRecognition.vue?vue&type=script&lang=js"
import style0 from "./ShapeRecognition.vue?vue&type=style&index=0&id=4b34327a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b34327a",
  null
  
)

export default component.exports